import React from 'react';
import PropTypes from 'prop-types';

import getActiveFilters from 'shared-utils/src/getActiveFilters';

import { CtxContainer } from '@client/app/Container';

import {
  showLicenceTypeGroupsButton,
  // showLicenceContractTypeGroupsButton,
} from '../../../helpers/search/Search';

import FallbackLoader from '../../../loaders/components/FallbackLoader';
import Skeleton from './skeleton';

class FiltersSkeleton extends React.Component {
  static contextType = CtxContainer;

  constructor(props) {
    super(props);

    this.state = {
      component: null,
      skeleton: null,
    };
  }

  componentWillMount() {
    const {
      globalSelector,
      model: {
        clientFilters: {
          activeFiltersOnSSr,
          skBox1,
          skBox2,
          skBox3,
          skBox4,
          skBox5,
        },
      },
      filtersProps: {
        isPublisherHP,
        isPublisherPage,
        isAgencySrp,
        filters,
        mainLocation,
        additionalLocations,
        startWithSelectedPtypes,
      },
    } = this.context;

    const onePTypeSelectCategories = [
      'stanza',
      'cantina-solaio',
      'garage-posti-auto',
      'nuova-costruzione',
    ];

    const hasPois = globalSelector('availablePoi').length > 0;

    const { activeFiltersList } = getActiveFilters(filters);

    let onePTypeSelect = startWithSelectedPtypes;
    if (filters.propertyTypeGroup && onePTypeSelectCategories.indexOf(filters.propertyTypeGroup) > -1) {
      onePTypeSelect = true;
    }    

    const skeleton = (
      <Skeleton
        isPublisherPage={isPublisherPage}
        isAgencySrp={isAgencySrp}
        mainLocation={mainLocation}
        additionalLocations={additionalLocations}
        qExpansion={filters.qExpansion}
        isCircleorNearby={filters?.geocircle || filters?.nearby}        
        activeFilters={activeFiltersOnSSr?.activeFiltersCount}
        hasPois={hasPois}
        isPoiActive={activeFiltersOnSSr?.activeFiltersList?.poi}        
        showPTypesButton={!isPublisherHP && !onePTypeSelect && !isAgencySrp && !(isPublisherPage && !activeFiltersList.category)}
        showLicenceTypeGroupsButton={showLicenceTypeGroupsButton(activeFiltersList)}        
        // showLicenceContractTypeGroupsButton={showLicenceContractTypeGroupsButton(filters)}
        skBox1={skBox1}
        skBox2={skBox2}
        skBox3={skBox3}
        skBox4={skBox4}
        skBox5={skBox5}
      />
    );

    const component = FallbackLoader(() => import(/* webpackChunkName: "async-filterSection" */'@components/common/FilterSection'), {
      fallback: skeleton,
    });

    this.setState({
      component,
      skeleton,
    });
  }

  render() {    
    const { showFilters } = this.props;
    const { component, skeleton } = this.state;
    const { filtersProps: { device, orientation } } = this.context;
    
    const Component = component;
    
    const fallBack = !device || device === 'desktop'
      ? skeleton
      : null;

    if (device === 'smartphone' || (device === 'tablet' && orientation === 'portrait')) {
      return null;
    }

    return showFilters
      ? <Component inModal={false} />
      : fallBack;
    // return fallBack;
  }
}

export default FiltersSkeleton;

FiltersSkeleton.propTypes = {
  showFilters: PropTypes.bool,
};

FiltersSkeleton.defaultProps = {
  showFilters: false,
};
